import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function KnownFault() {
    return ReferralCriteria({
        statement: (
            <p>
                Refer to regional genetics with the name of the affected individual and where tested.
            </p>
        )
    });
}

export default KnownFault;
